// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UBo4","newExpiryDate":"styles_newExpiryDate__1EFG4","footer":"styles_footer__27oPK"};